export default "__VITE_ASSET__CeJsen$___"